export const PASSWORD_MANAGER = {
  TITLE: 'Password Manager',
  VAULT: {
    TITLE: 'Password Vault',
    DESCRIPTION: "Access your organization's password vault to securely manage shared credentials.",
    URLS: {
      ACCESS: 'Access Password Vault',
    },
  },
  EXTENSION: {
    TITLE: 'Browser Extension',
    DESCRIPTION: 'Install our password manager browser extension for seamless access to your credentials.',
    URLS: {
      DOWNLOAD: 'Download Google Chrome Extension',
    },
  },
  DOCUMENTATION: {
    TITLE: 'Documentation',
    DESCRIPTION: 'Learn how to effectively use our password management tools and best practices for password security.',
    URLS: {
      GUIDE: 'Password Manager Handbook',
      EXTENSION: 'Installing Google Chrome Extension',
    },
  },
  INSIGHTS: {
    TITLE: 'Password Security Insights',
    DESCRIPTION:
      "Review password security insights and recommendations to strengthen your organization's " +
      'password practices. Monitor password health, identify weak or reused passwords, ' +
      'and track improvement over time.',
    NO_INSIGHTS_AVAILABLE:
      'Password insights will be available once sufficient data has been collected. ' +
      'Please check back later to review password security patterns and recommendations.',
  },
}
